import { OfflineProductInterface } from '@/interfaces/OfflineProduct.interface';
import ApiClient from '../ApiClient';
import BaseApiClient from '../BaseApiClient';
import { ListDataParams, ListDataResponse } from '../types';

export class ApiOfflineProducts extends BaseApiClient {
  private api!: ApiClient;

  setApiClient(api: ApiClient) {
    this.api = api;
  }

  async list(
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<OfflineProductInterface>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.name = searchTerm;
      }
      this.client
        .getList('/offline-products', listData, {
          headers: {
            Version: '2025-11-14'
          }
        })
        .then(({ data }) => {
          if (data) {
            resolve({
              items: data.data,
              pagination: {
                page: data.meta?.page,
                perPage: data.meta?.per_page,
                total: data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  async create(data: Partial<OfflineProductInterface>) {
    return await this.client.post('/offline-products', data, {
      headers: {
        Version: '2025-11-14'
      }
    });
  }

  async update(uuid: string, data: Partial<OfflineProductInterface>) {
    return await this.client.put(`/offline-products/${uuid}`, data, {
      headers: {
        Version: '2025-11-14'
      }
    });
  }

  async delete(uuid: string) {
    return await this.client.delete(`/offline-products/${uuid}`, {
      headers: {
        Version: '2025-11-14'
      }
    });
  }
}

export { offlineProductsQueryKeys } from './query-keys';
export type { OfflineProductsListQueryParams } from './query-keys';
export { useOfflineProductsListQuery } from './use-offline-products-queries';
export {
  useOfflineProductsCreateMutation,
  useOfflineProductsDeleteMutation,
  useOfflineProductsUpdateMutation
} from './use-offline-products-mutations';
export type {
  OfflineProductsCreateVariables,
  OfflineProductsUpdateVariables
} from './use-offline-products-mutations';
